module.exports = __webpack_public_path__ + "static/media/team_2.35742558.png";